import { NavLink } from "react-router-dom";

// A module with one sidebar entry but more than one page (EOS-03 source sizing,
// EOS-05 protection coordination) moves between its pages with this switch at the
// top of each page. Every switch renders the same markup and the same styling hook,
// `nav[data-module-switch]` (styled in styles/study.css), so a new switch cannot come
// out as a plain list of links. NavLink marks the open page with aria-current="page".

export type ModulePage = { readonly to: string; readonly label: string };

type ModuleSwitchProps = {
  /** The accessible name of the switch, e.g. "Source sizing". */
  label: string;
  pages: readonly ModulePage[];
};

export function ModuleSwitch({ label, pages }: ModuleSwitchProps) {
  return (
    <nav aria-label={label} data-module-switch>
      <ul>
        {pages.map((page) => (
          <li key={page.to}>
            <NavLink to={page.to} end>
              {page.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default ModuleSwitch;
